"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function OrderId(_ref) {
  var externalId = _ref.externalId,
      id = _ref.id;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-locator": "invoice.order.id",
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      "data-locator": "invoice.external-id"
    }, externalId)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "invoice.id"
    }, "ID \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438: ", id)));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = OrderId;
exports["default"] = _default;